import type { JSX } from 'solid-js';

const colorMap: Record<string, string> = {
    '0': '#000000', '1': '#0000AA', '2': '#00AA00', '3': '#00AAAA',
    '4': '#AA0000', '5': '#AA00AA', '6': '#FFAA00', '7': '#AAAAAA',
    '8': '#555555', '9': '#5555FF', 'a': '#55FF55', 'b': '#55FFFF',
    'c': '#FF5555', 'd': '#FF55FF', 'e': '#FFFF55', 'f': '#FFFFFF',
};

export function formatMinecraftText(text: string): JSX.Element[] {
    const parts = text.split(/(§[0-9a-fk-or])/i);
    let currentColor = '#FFFFFF';
    let isBold = false;
    let isItalic = false;
    let isUnderline = false;
    let isStrikethrough = false;

    return parts.map((part) => {
        if (part.startsWith('§')) {
            const code = part[1].toLowerCase();
            if (code === 'r') {
                currentColor = '#FFFFFF';
                isBold = false;
                isItalic = false;
                isUnderline = false;
                isStrikethrough = false;
            } else if (code === 'l') {
                isBold = true;
            } else if (code === 'o') {
                isItalic = true;
            } else if (code === 'n') {
                isUnderline = true;
            } else if (code === 'm') {
                isStrikethrough = true;
            } else if (code === 'k') {
                // obfuscated — no visual equivalent
            } else {
                currentColor = colorMap[code] || '#FFFFFF';
            }
            return null;
        }
        if (!part) return null;

        const decoration = [
            isUnderline ? 'underline' : '',
            isStrikethrough ? 'line-through' : '',
        ].filter(Boolean).join(' ') || 'none';

        return (
            <span style={{
                color: currentColor,
                "font-weight": isBold ? 'bold' : 'normal',
                "font-style": isItalic ? 'italic' : 'normal',
                "text-decoration": decoration,
            }}>
                {part}
            </span>
        );
    }).filter(Boolean) as JSX.Element[];
}

export default function MinecraftText(props: { text: string }) {
    return <>{formatMinecraftText(props.text)}</>;
}

export const AMPERSAND_CODE_REGEX = /&[0-9a-fk-or]/i;

export function formatAmpersandText(text: string): JSX.Element[] {
    return formatMinecraftText(text.replace(/&([0-9a-fk-or])/gi, '§$1'));
}
